import React from 'react';
import { Link } from 'react-router-dom';
import { useLocation } from 'react-router';
import { theme } from '../Theming/Theming';
import { styled } from 'linaria/react';

const SubNav = styled('div')`
  border-right: 1px solid ${theme.colors.border};
  padding-right: 1rem;
  > a {
    display: block;
    text-transform: uppercase;
    letter-spacing: 1px;
    border-bottom: 1px solid ${theme.colors.border};
    padding: 10px 0;
    &[data-level='1'] {
      font-size: 1.3rem;
      margin-bottom: 1rem;
      border-bottom: none;
    }
    &[data-level='2'] {
      font-size: 1rem;
    }
    &[data-level='3'] {
      font-size: 0.9rem;
      background: #f5f5f5;
      margin: 0;
      padding: 10px;
    }
    &.active {
      font-weight: ${theme.weights.bold};
    }
  }
`;

const SubPagesWrapper = styled('div')`
  display: flex;
  margin-bottom: 1rem;
  > a {
    display: block;
    margin-right: 1rem;
    border-bottom: 1px solid white;
    &.active {
      border-color: #777;
    }
  }
`;

function getNavigationItemFromPage(page, level) {
  return {
    id: page.id,
    name: page.name,
    url: page.primaryRoute?.path,
    level,
  };
}

function getNavigationItems(page) {
  const grandParent = page.parent?.parent
    ? getNavigationItemFromPage(page.parent.parent, 1)
    : null;
  const grandSiblings = page.parent?.parent
    ? page.parent.parent.subPages.map((subPage) =>
        getNavigationItemFromPage(subPage, 2)
      )
    : [];
  const parent = page.parent
    ? getNavigationItemFromPage(page.parent, grandParent ? 2 : 1)
    : null;
  const siblings = page.parent
    ? page.parent.subPages.map((subPage) =>
        getNavigationItemFromPage(subPage, grandParent ? 3 : 2)
      )
    : [];
  const subPages = page.subPages
    ? page.subPages.map((subPage) =>
        getNavigationItemFromPage(subPage, parent ? 3 : 2)
      )
    : [];
  const currentPage = getNavigationItemFromPage(
    page,
    parent ? 2 : grandParent ? 3 : 1
  );

  if (!parent && !subPages?.length) return [];

  const items = [];

  if (grandParent) items.push(grandParent);
  if (grandSiblings.length) {
    grandSiblings.forEach((page) => {
      items.push(page);
      if (page.id === parent.id) {
        items.push(...siblings);
      }
    });
  } else {
    if (parent) items.push(parent);
    if (siblings.length) {
      siblings.forEach((page) => {
        items.push(page);
        if (page.id === currentPage.id) {
          items.push(...subPages);
        }
      });
    } else {
      items.push(currentPage, ...subPages);
    }
  }

  return items;
}

export function shouldDisplayNavigation(page) {
  return Boolean(page?.parent || page?.subPages?.length);
}

export const SubPages = ({ page }) => {
  console.log(page);
  const list = page.subPages.length > 0 ? page.subPages : page.parent.subPages;
  return (
    <SubPagesWrapper>
      {list.map((subPage) => (
        <Link
          className={`${subPage.id === page.id ? 'active' : ''}`}
          to={subPage.primaryRoute?.path}
        >
          {subPage.name}
        </Link>
      ))}
    </SubPagesWrapper>
  );
};

export const SubNavigation = ({ page }) => {
  const location = useLocation();
  const items = getNavigationItems(page);
  return (
    <SubNav>
      {items.map((item) => (
        <Link
          data-level={item.level}
          key={item.id}
          to={item.url}
          className={`${location.pathname === item.url ? 'active' : ''}`}
        >
          {item.name}
        </Link>
      ))}
    </SubNav>
  );
};
